module.exports = (count) => {
  if (count === 0) {
    return 'zero';
  } else if (count === 1) {
    return 'one';
  } else {
    return 'other';
  }
};
